import React, { ReactElement } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import useCustomCursor from '@system/hooks/useCustomCursor'
import Icon from '@components/core/icon'
import FontSize from '@config/theme/definitions/fontSize'

const useStyles = makeStyles((theme) => ({
  root: {
    '@media (hover: hover)': {
      '&:hover $icon': {
        '&::before': {
          transform: 'scale(1)',
        },
      },
    },
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: FontSize['lg'],
    lineHeight: 1.11111,
  },
  icon: {
    position: 'relative',
    display: 'inline-block',
    marginRight: theme.spacing(4),
    border: 0,
    outline: 0,
    background: 'none',
    padding: 0,
    font: 'inherit',
    color: 'inherit',
    '@media (hover: hover)': {
      '&::before': {
        content: '""',
        position: 'absolute',
        display: 'block',
        top: '50%',
        left: '50%',
        width: '48px',
        height: '48px',
        backgroundColor: '#29ace3',
        borderRadius: '50%',
        margin: '-24px',
        transform: 'scale(0)',
        transition: 'transform 0.3s',
      },
      '&:hover': {
        color: theme.palette.text.primary,
      },
    },
  },
  iconSvg: {
    position: 'relative',
  },
}))

export type DownloadProps = DBN.IReactDefaultProps & {
  to?: string
}

export default function Download({
  to,
  children,
  className,
  ...props
}: DownloadProps): ReactElement {
  const classes = useStyles()
  const { setCursorType } = useCustomCursor()

  return (
    <a
      className={clsx(className, classes.root)}
      href={to}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setCursorType('hide')}
      onMouseLeave={() => setCursorType('')}
      {...props}
    >
      <span className={classes.icon}>
        <Icon name="Download" className={classes.iconSvg} />
      </span>
      <span>{children}</span>
    </a>
  )
}
